import { FC, ReactNode } from 'react';
import styles from './barStyles.module.scss';
import { Panel } from 'react-resizable-panels';
import { ExpandedPanelsContextProvider } from './settingsPanel/settingsPanelContextProvider';
import { SettingsPanel } from './settingsPanel/settingsPanel.component';

export const RightBar: FC<{ formConfigSettingPanel: ReactNode }> = ({ formConfigSettingPanel }) => {
  return (
    <Panel minSize={17} maxSize={50} defaultSize={17} className={styles.toolboxContainer}>
      <ExpandedPanelsContextProvider>
        <SettingsPanel formConfigSettingPanel={formConfigSettingPanel} />
      </ExpandedPanelsContextProvider>
    </Panel>
  );
};
